import api from '@/api';

export default {
  // 查询-提前训练计划预案列表
  getPlanLeaderOrCoach (params) {
    return api({
      url: '/event/trainingPlanInfo/pageAheadTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 查询-提前训练计划预案列表
  getPlanLeaderOrCoachToTrainingNumber (params) {
    return api({
      url: '/event/trainingPlanInfo/listAheadTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getPlanSystem (params) {
    return api({
      url: '/event/ahead/pageAheadTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getPlanSystemToTrainingNumber (params) {
    return api({
      url: '/event/ahead/listAheadTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-会员协会调用
  getPlanListOrgan (params) {
    return api({
      url: '/event/ahead/pageAheadTrainListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-会员协会调用
  getPlanListOrganToTrainingNumber (params) {
    return api({
      url: '/event/ahead/listAheadTrainListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-青训中心调用
  getPlanListYouth (params) {
    return api({
      url: '/event/ahead/pageAheadTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-青训中心调用
  getPlanListYouthToTrainingNumber (params) {
    return api({
      url: '/event/ahead/listAheadTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getPlanSystemToYouth (params) {
    return api({
      url: '/event/ahead/pageAheadTrainListToYouthSystem',
      method: 'GET',
      params
    })
  },

  // 添加-提前训练计划预案列表
  addPlan (data) {
    return api({
      url: '/event/ahead',
      method: 'POST',
      data
    })
  },
  // 修改-提前训练计划预案列表
  updatePlan (data) {
    return api({
      url: '/event/ahead',
      method: 'PUT',
      data
    })
  },
  // 添加-提前训练计划预案列表
  addPlanYear (data) {
    return api({
      url: '/event/year/yearTrainAdd',
      method: 'POST',
      data
    })
  },
  // 修改-提前训练计划预案列表
  updatePlanYear (data) {
    return api({
      url: '/event/year/yearTrainEdit',
      method: 'POST',
      data
    })
  },
  
  // 添加-提前训练计划预案列表
  addPlanHalfYear (data) {
    return api({
      url: '/event/year/halfYearTrainAdd',
      method: 'POST',
      data
    })
  },
  // 修改-提前训练计划预案列表
  updatePlanHalfYear (data) {
    return api({
      url: '/event/year/halfYearTrainEdit',
      method: 'POST',
      data
    })
  },
  // 添加-提前训练计划预案列表
  addPlanMonth (data) {
    return api({
      url: '/event/year/monthTrainAdd',
      method: 'POST',
      data
    })
  },
  // 修改-提前训练计划预案列表
  updatePlanMonth (data) {
    return api({
      url: '/event/year/monthTrainEdit',
      method: 'POST',
      data
    })
  },
  // 删除-提前训练计划预案列表
  deletePlan (uuid) {
    return api({
      url: `/event/ahead/${uuid}`,
      method: 'DELETE'
    })
  },
  // 查看详情
  getAheadTrainListView (uuid) {
    return api({
      url: `/event/ahead/aheadTrainListView/${uuid}`,
      method: 'GET'
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getYearPlanSystem (params) {
    return api({
      url: '/event/year/pageYearTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getYearPlanOrgan (params) {
    return api({
      url: '/event/year/pageyearTrainListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getYearPlanYouth (params) {
    return api({
      url: '/event/year/pageYearTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getYearPlanCoach (params) {
    return api({
      url: '/event/trainingPlanInfo/pageYearTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 获取完成状态训练计划的详细信息
  getYearTrainDetail (trainingPlanUuid) {
    return api({
      url: `/event/year/yearTrainListView/${trainingPlanUuid}`,
      method: 'GET'
    })
  },
  // 获取完成状态训练计划的详细信息
  yearTrainRemove (trainingPlanUuid) {
    return api({
      url: `/event/year/yearTrainListRemove/${trainingPlanUuid}`,
      method: 'POST'
    })
  },
  
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getHalfYearPlanSystem (params) {
    return api({
      url: '/event/year/pageHalfYearTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getHalfYearPlanOrgan (params) {
    return api({
      url: '/event/year/pageHalfyearTrainListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getHalfYearPlanYouth (params) {
    return api({
      url: '/event/year/pageHalfYearTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getHalfYearPlanCoach (params) {
    return api({
      url: '/event/trainingPlanInfo/pageHalfYearTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 获取完成状态训练计划的详细信息
  getHalfYearTrainDetail (trainingPlanUuid) {
    return api({
      url: `/event/year/halfYearTrainListView/${trainingPlanUuid}`,
      method: 'GET'
    })
  },
  // 获取完成状态训练计划的详细信息
  halfYearTrainRemove (trainingPlanUuid) {
    return api({
      url: `/event/year/halfYearTrainListRemove/${trainingPlanUuid}`,
      method: 'POST'
    })
  },
  
  
  
  
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getMonthPlanSystem (params) {
    return api({
      url: '/event/year/pageMonthTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getMonthPlanOrgan (params) {
    return api({
      url: '/event/year/pageMonthTrainListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getMonthPlanYouth (params) {
    return api({
      url: '/event/year/pageMonthTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getMonthPlanCoach (params) {
    return api({
      url: '/event/trainingPlanInfo/pageMonthTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 获取完成状态训练计划的详细信息
  getMonthTrainDetail (trainingPlanUuid) {
    return api({
      url: `/event/year/monthTrainListView/${trainingPlanUuid}`,
      method: 'GET'
    })
  },
  // 获取完成状态训练计划的详细信息
  monthTrainRemove (trainingPlanUuid) {
    return api({
      url: `/event/year/monthTrainListRemove/${trainingPlanUuid}`,
      method: 'POST'
    })
  },
}

